module.exports = __webpack_public_path__ + "components/MapControl/gravePopup/img/flame.png?e7175dc6";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/gravePopup/img/flame.png
// module id = 1930
// module chunks = 0